import { Dialog } from '@sr/ui-library';
import { globalService } from '../reducers/globalState/globalStateSlice';
import { reduxServices } from '../reducers/reduxServices';
import { useAppDispatch, useTypedSelector } from '../stateStore';

export interface IErrorModalProps {
  isOpen?: boolean;
  noInternet?: boolean;
  onDismiss?: (value: boolean) => void;
  responseError?: boolean;
}

export const ErrorModal = ({
  isOpen,
  noInternet,
  onDismiss,
}: IErrorModalProps) => {
  const dispatch = useAppDispatch();
  const currentError = useTypedSelector(globalService.selectors.currentError);
  const networkError = () =>
    currentError?.code === 'ERR_NETWORK' || noInternet || !navigator.onLine;

  const handleDismissClick = () => {
    dispatch(reduxServices.globalState.actions.setShowErrorModal(false));
    onDismiss?.(false);
  };

  return (
    <Dialog
      heading={
        networkError()
          ? 'There is no internet connection'
          : 'Sorry, something went wrong'
      }
      actionButtonProps={{
        children: 'OK',
        onClick: handleDismissClick,
      }}
      hasCancelButton={false}
      open={isOpen}
      onOpenChange={handleDismissClick}
    >
      {networkError() ? (
        <p>Please check the connection and try again.</p>
      ) : (
        <p>
          There&rsquo;s an error on our end.
          <br />
          Try again later.
        </p>
      )}
    </Dialog>
  );
};

export default ErrorModal;
